export const INITIAL_LIST = {
    count: 0,
    page: 1,
    isLoading: false,
    results: {},
    allIds: [],
    errors: {},
    filters: {},
};
